import axios from "axios"
import { mapGetters } from "vuex";
import { ErrorLogService } from ".";

export const CatalogService = Object.freeze({
  GetChildCategories: async function (accountId, userId, parentId, brandAuth, regionAuth, userAudiences, parentIds = null) {    
    var reqUrl = window.appGlobals.API_URL + "Catalog/ChildCategories";
    var retryCounter = 0
    do {
      try{
      retryCounter++;
      var results = await axios.post(reqUrl,
          {
            AccountId: accountId,
            UserId: userId,
            ParentId: parentId,
            BrandAuth: brandAuth,
            RegionAuth: regionAuth,
            UserAudiences: userAudiences,
            ParentIds: parentIds
          });
          if(results != undefined){
            return results;
          }
        }
        catch(error){
          // Swallow error
        }
    }
    while(retryCounter < 4);
    // Log error if retry loop isn't successful
    ErrorLogService.LogException( "Error loading catalog");
  },
  GetCategory: function ( accountId, userId, categoryid, userAudiences){        
    var reqUrl = window.appGlobals.API_URL + "Catalog/Category";
    return axios.post(reqUrl,{
          AccountId: accountId,
          UserId: userId,
          CategoryId: categoryid,
          UserAudiences: userAudiences
        });
  },
  GetTelematicsCategoryIds: function () {
    return axios.get(window.appGlobals.API_URL + "Catalog/TelematicsCategoryIds");
  },
  GetMediaUrl: function (fileId) {
    return window.appGlobals.PART_IMAGES_API_URL + "Media/FileById?id=" + fileId;
  },
  GetCategoryContentByTypes: function (categoryId, contentTypes) {
    var reqUrl = `${window.appGlobals.API_URL}Catalog/GetCategoryContentByTypes?categoryId=${categoryId}`;
    return axios.post(reqUrl, contentTypes);
  },
  GetCategoryParts: function ( accountId, userId, categoryId, pageNumber, facets , categoryName, searchId, sortTerm, sortDirection, pageSize, inStock) {
    var reqUrl = window.appGlobals.API_URL + "Catalog/CategoryPartSearch";
  
    return axios.post(reqUrl, {
      AccountId: accountId,
      UserId: userId,
      CategoryId: categoryId,
      PageNumber: pageNumber,
      PageSize: pageSize,
      SelectedFacets: facets,
      CategoryName: categoryName,
      SearchId: searchId,
      SortField: sortTerm,
      SortDirection: sortDirection,
      InStock: inStock
    });
  },
  GetCategoriesByKeyword: function(accountId, userId, searchTerm, userAudiences) {
    var reqUrl = window.appGlobals.API_URL + "Catalog/Search";
    return axios.post(reqUrl, {
      AccountId: accountId,
      UserId: userId,
      SearchTerm: searchTerm,
      UserAudiences: userAudiences
    });
  },
  GetKits: function(accountId, userId, categoryId){
    var reqUrl = window.appGlobals.API_URL + `Catalog/GetKits?accountId=${accountId}&userId=${userId}&categoryId=${categoryId}`;
    return axios.get(reqUrl);
  }
})
